import React, { useEffect } from "react";
import ToolBoxTalkUserList from "../component/toolBoxTalkList/toolBoxTalkUserList";
import { useDispatch, useSelector } from "react-redux";
import { ORG_ID, USER_ID } from "../../../constant/constant";
import * as toolboxAction from "../../../redux/actions/toolBoxAction";
import * as adminAction from "../../../redux/actions/adminCommonAction";
import { useLocation } from "react-router-dom";

const ToolboxTalkUserContainer = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const safetyMeetingUser = location?.state?.safetyMeetingUser ?? false;
  const PAGE_SIZE = 6;
  const defaultTab = location?.state?.defaultTab;
  const mySafetyMeetingListResult = useSelector(
    (state) => state.mySafetyMeetingList?.data
  );
  const cleardata = () => {
    dispatch(toolboxAction.clearMySafetyMeetingList(""));
  };
  const dropdownDataKeyValue = useSelector(
    (state) => state.getDropdownDataKeyValue?.data?.toolboxCategories
  );

  const getAdminToolBoxTalkListData = useSelector(
    (state) => state.getAdminToolBoxTalkList
  );

  useEffect(() => {
    cleardata();
    const data = {
      page: 1,
      pageSize: PAGE_SIZE,
      search: "",
      userId: parseInt(USER_ID()),
      tabId: defaultTab === 1 ? 3 : 2,
    };

    getMySafetyMeetingListData(data);
    dispatch(toolboxAction.getScheduleSafetyMeetingDetailsClear(""));
  }, [defaultTab]);
  const getMySafetyMeetingListData = (data) => {
    dispatch(toolboxAction.clearUserDetailTalk(data));
    dispatch(toolboxAction.getMySafetyMeetingList(data));
  };

  const getDropdownDataKeyValueData = {
    orgId: ORG_ID(),
    flags: [20],
  };

  useEffect(() => {
    dispatch(adminAction.getDropdownDataKeyValue(getDropdownDataKeyValueData));
  }, []);

  const getAdminToolBoxTalkList = (data) => {
    dispatch(toolboxAction.getAdminToolBoxTalkList(data));
  };
  return (
    <>
      <ToolBoxTalkUserList
        categoryListData={dropdownDataKeyValue}
        getToolBoxTalkListResult={mySafetyMeetingListResult}
        getToolBoxTalkListData={getMySafetyMeetingListData}
        getToolBoxTalkListAdmin={getAdminToolBoxTalkList} // function
        getAdminToolBoxTalkListDataLoading={
          getAdminToolBoxTalkListData?.isLoading
        } // data
        getAdminToolBoxTalkListData={getAdminToolBoxTalkListData?.data}
        safetyMeetingUser={safetyMeetingUser}
        cleardata={cleardata}
      />
    </>
  );
};

export default ToolboxTalkUserContainer;
